import * as React from "react";
import { forwardRef } from "react";
const LogoDolyameSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#000" }),
    React.createElement("path", { fill: "#fff", d: "M17.714 4.902H20v10.5h-2.286zM13.143 6.069h2.286v10.5h-2.286zM10.857 7.235H8.571v10.5h2.286zM4 8.402h2.286v10.5H4z" }));
const ForwardRef = forwardRef(LogoDolyameSVG);
export default ForwardRef;
//# sourceMappingURL=LogoDolyame.js.map